import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Badge, Container } from '@pella/sash-framework';
import { Layout, SEO, Breadcrumbs, Image, CTA } from '../../components';

import LocalNavTop from '../../components/common/local-nav-top';
import EmployeeCard from '../../components/template/branch-team/employee-card';

const BranchTeam = (props) => {
	const pageData = props.data.contentstackBranchTeam;

	return (
		<Layout id='template-BranchTeam'>
			{pageData?.branch_data?.[0]?.local_nav?.[0] && (
				<LocalNavTop
					branchData={pageData.branch_data[0]}
					linksArray={pageData.branch_data[0].local_nav}
					isAnchors={false}
					currentUrl={pageData.url}
				/>
			)}

			{pageData.breadcrumbs && (
				<Breadcrumbs
					data={pageData.breadcrumbs}
					currentUrl={pageData.url}
				/>
			)}

			{pageData.hero && (
				<div className={`branchTeam-hero bg-gray-5 py-6 md:py-8 ${pageData.hero.image?.[0] ? 'xl:py-10' : ''}`}>
					<Container className={`grid grid-cols-1 items-center gap-x-10 ${pageData.hero.image?.[0] ? 'xl:auto-cols-fr' : ''}`}>
						{pageData.hero.image?.[0] && (
							<Image
								data={pageData.hero.image[0]}
								className='row-start-1 mb-6 aspect-[3/2] md:mb-9 xl:col-start-2 xl:mb-0'
							/>
						)}

						<div className={`md:col-start-1 ${pageData.hero.image?.[0] ? 'row-start-2 xl:row-start-1' : 'row-start-1'}`}>
							{pageData.hero.heading && (
								<h1
									dangerouslySetInnerHTML={{ __html: pageData.hero.heading }}
									className='text-h2 mb-5 md:mb-6'
								/>
							)}
							{pageData.hero.description && (
								<div
									dangerouslySetInnerHTML={{ __html: pageData.hero.description }}
									className='text-subtitle'
								/>
							)}
						</div>
					</Container>
				</div>
			)}

			{pageData.modular_blocks?.[0] &&
				pageData.modular_blocks.map((block, index) => {
					if (block.team_members != null) {
						return (
							<div
								key={index}
								className='branchTeam-members py-9 md:px-[68px] xl:px-0'
							>
								<Container>
									{block.team_members.heading && (
										<h2 className='mb-9'>
											<Badge
												color='black'
												className='!px-3'
											>
												{block.team_members.heading}
											</Badge>
										</h2>
									)}

									{block.team_members.bios?.[0] && (
										<div className='grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4'>
											{block.team_members.bios.map((member, index) => (
												<EmployeeCard
													bio={member}
													key={index}
												/>
											))}
										</div>
									)}
								</Container>
							</div>
						);
					}

					if (block.cta_banner != null) {
						return (
							<div
								key={index}
								className='branchTeam-ctaBanner px-6 py-12 md:px-16'
								style={{ backgroundColor: block.cta_banner.background_hex_value }}
							>
								<Container>
									<div
										style={{ backgroundColor: block.cta_banner.container_hex_value }}
										className='px-6 py-12 text-center md:px-16'
									>
										{block.cta_banner.heading && (
											<h2
												className='m-0'
												dangerouslySetInnerHTML={{ __html: block.cta_banner.heading }}
											/>
										)}
										{block.cta_banner.subheading && (
											<div
												className='text-subtitle mt-6'
												dangerouslySetInnerHTML={{ __html: block.cta_banner.subheading }}
											/>
										)}
										{block.cta_banner.cta?.[0] && (
											<CTA
												className='mt-6'
												data={block.cta_banner.cta[0]}
											/>
										)}
									</div>
								</Container>
							</div>
						);
					}
				})}
		</Layout>
	);
};

BranchTeam.propTypes = {
	data: PropTypes.object,
};

export default BranchTeam;

// eslint-disable-next-line react/prop-types -- gatsby component
export const Head = ({ data }) => <SEO {...data.contentstackBranchTeam.seo} />;

export const query = graphql`
	query ($uid: String!) {
		contentstackBranchTeam(id: { eq: $uid }) {
			url
			breadcrumbs {
				...Breadcrumbs
			}
			branch_data {
				...BranchData
			}
			branch_id
			hero {
				heading
				description
				image {
					...Image
					image {
						url
						gatsbyImageData(quality: 90)
					}
				}
			}
			modular_blocks {
				team_members {
					heading
					bios {
						...Author
					}
				}
				cta_banner {
					background_hex_value
					container_hex_value
					heading
					subheading
					cta {
						...CTA
					}
				}
			}
			seo {
				...SEO
			}
		}
	}
`;
